import { InfoOutlined } from "@mui/icons-material";
import { Stack, Typography, useTheme } from "@mui/material";

const JobTitleTooltipContent = () => {
  const theme = useTheme();

  return (
    <Stack spacing={0.5}>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: "baseline" }}>
        <InfoOutlined sx={{ position: "relative", top: "2px" }} />
        <Typography variant="body2">Job Titles</Typography>
      </Stack>
      <Stack spacing={0.25}>
        <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
          Job title refers to the designation jointly determined by the company's People Ops, the team lead, and the
          employee. It serves as the official reference for external communications, including:
        </Typography>

        <Stack spacing={0.2} sx={{ pl: 0.5 }}>
          <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
            • Interactions with clients, partners, and media
          </Typography>
          <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
            • Legal representation of the company
          </Typography>
          <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
            • Business cards and online profiles
          </Typography>
        </Stack>

        <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
          Within CODE OS, Job Titles are optional. When assigned, their primary records are maintained by the People Ops
          team.
        </Typography>
        <Typography variant="caption" sx={{ color: theme.palette.text.primary }}>
          Roles, in contrast, are dynamic functions that exist to support the team's purpose and objectives. Roles are
          not tied to individuals like Job Titles. Instead, they represent specific areas of responsibility,
          decision-making authority, and ongoing work that the team has identified as necessary.
        </Typography>
      </Stack>
    </Stack>
  );
};

export { JobTitleTooltipContent };
